import React, { ButtonHTMLAttributes } from "react";

export interface PrimaryBtnProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  style?: "fill" | "line";
  color?: "main-gr" | "main" | "gray";
}

const getTailwind = (style: string, color: string, disabled: boolean) => {
  if (style === "fill") {
    if (disabled) {
      if (color === "main-gr" || color === "main") {
        return "bg-[#eeeeee] text-[#888888] font-medium";
      }
      if (color === "gray") {
        return "bg-[#eeeeee] text-[#888888] font-semibold";
      }
    } else {
      if (color === "main-gr") {
        return "bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa] text-white font-bold hover:from-[#ab38a6] hover:via-[#4927b9] hover:to-[#2b78cf]";
      }
      if (color === "main") {
        return "bg-[#6d2ef2] text-white font-bold hover:bg-[#5e2bc8]";
      }
      if (color === "gray") {
        return "bg-[#212121] text-white font-semibold hover:bg-[#4d4d4d]";
      }
    }
  } else if (style === "line") {
    if (disabled) {
      if (color === "main-gr") {
        return "border border-[#cccccc] bg-white text-[#888888] font-medium";
      }
    } else {
      if (color === "main-gr") {
        return "border border-[#cccccc] bg-white text-[#666666] font-medium hover:bg-[#f7f7f7] hover:text-[#666666]";
      }
    }
  }
  return "bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa] text-white font-bold hover:from-[#ab38a6] hover:via-[#4927b9] hover:to-[#2b78cf]";
};

const Primary: React.FC<PrimaryBtnProps> = ({
  style = "fill",
  color = "main-gr",
  disabled = false,
  className,
  ...props
}) => {
  const base =
    "box-border flex items-center justify-center min-h-[48px] max-h-[48px] h-[48px] w-[100%] md:w-fit max-w-[800px] px-10 py-0 rounded-[24px] text-[16px] leading-[24px] tracking-[-0.32px] text-center transition-all duration-200";
  const tw = getTailwind(style, color, disabled);

  return (
    <button
      className={`${base} ${tw} ${className}`}
      disabled={disabled}
      {...props}
    />
  );
};

export default Primary;
